import { render, staticRenderFns } from "./InternetCheck.vue?vue&type=template&id=70698915&"
import script from "./InternetCheck.vue?vue&type=script&lang=js&"
export * from "./InternetCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports